module.exports = __webpack_public_path__ + "static/img/h1-3.5e8d3d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h1-3.png
// module id = Td7X
// module chunks = 1